export default "__VITE_ASSET__CxrlgR$s__"